import { InvestmentPackageSettings } from './InvestmentPackageSettings';

function numberOr(value: unknown): number | null {
  return typeof value === 'number' && !Number.isNaN(value) ? value : null;
}

function nullableNumber(value: unknown): number | null {
  return typeof value === 'number' && !Number.isNaN(value) ? value : null;
}

function stringArray(value: unknown): string[] {
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === 'string')
    : [];
}

function resolveMinAmount(raw: Record<string, unknown>): number | null {
  const minAmount = numberOr(raw.minAmount);
  if (minAmount !== null) {
    return minAmount;
  }

  const minMoney = raw.minMoney;
  if (minMoney && typeof minMoney === 'object') {
    const amount = (minMoney as { amount?: unknown }).amount;
    return numberOr(amount);
  }

  return null;
}

export function normalizeInvestmentPackageSettings(
  data: unknown
): InvestmentPackageSettings | null {
  if (!data || typeof data !== 'object') {
    return null;
  }

  const raw = data as Record<string, unknown>;
  const dealsCount = numberOr(raw.dealsCount ?? raw.maxDealsCount);
  const minAmount = resolveMinAmount(raw);

  if (dealsCount === null || minAmount === null) {
    return null;
  }

  return {
    dealsCount,
    minAmount,
    economicClasses: stringArray(raw.economicClasses),
    legalClasses: stringArray(raw.legalClasses),
    minTerm: nullableNumber(raw.minTerm),
    maxTerm: nullableNumber(raw.maxTerm),
    enableIncasso: Boolean(raw.enableIncasso),
    enableSameBorrower: Boolean(raw.enableSameBorrower),
  };
}
